import { NavigateFunction } from 'react-router-dom';
import { IMaintenanceError } from 'core/model/interfaces/error.interface';

export class MaintenanceUtils {
  private static instance: MaintenanceUtils | null = null;
  private navigateFn: NavigateFunction | null = null;
  private maintenanceError: IMaintenanceError['error'] | null = null;

  private constructor() {}

  public static getInstance(): MaintenanceUtils {
    MaintenanceUtils.instance ??= new MaintenanceUtils();
    return MaintenanceUtils.instance;
  }

  public setNavigate(navigate: NavigateFunction): void {
    this.navigateFn = navigate;
  }

  public getNavigate(): NavigateFunction | null {
    return this.navigateFn;
  }

  public setMaintenanceError(error: IMaintenanceError['error'] | null): void {
    this.maintenanceError = error;
  }

  public getMaintenanceError(): IMaintenanceError['error'] | null {
    return this.maintenanceError;
  }
}

export const setNavigate = (navigate: NavigateFunction) => {
  MaintenanceUtils.getInstance().setNavigate(navigate);
};

export const getNavigate = () => MaintenanceUtils.getInstance().getNavigate();

export const setMaintenanceError = (error: IMaintenanceError['error'] | null) => {
  MaintenanceUtils.getInstance().setMaintenanceError(error);
};

export const getMaintenanceError = () => MaintenanceUtils.getInstance().getMaintenanceError();

export default MaintenanceUtils;
